// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_SalvarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/service_priorities/salvar
 *
 * Wire shape preserved from legacy: `dados: <int>` — the saved record's
 * so_service_priority_id emitted directly as a primitive integer.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServicePriorities_SalvarResponseDados = number;

export type ServicePriorities_SalvarResponse = ApiResponse<ServicePriorities_SalvarResponseDados>;

registerResponseContract('ServicePriorities_SalvarResponse', {})
